module.exports = __webpack_public_path__ + "6efa25633181d93561d5ba710b27e946.png";